import styled from 'styled-components';
import { Dropdown, Typography } from '@/components/atoms';
import { useTranslation } from 'react-i18next';
import { Option } from '@/types/catalog';
import React, { useEffect, useState } from 'react';

interface OptionsDropdownProps {
  options: Option[];
  selectedColor: string | undefined;
  onChangeHandler: (type: string, value: string) => void;
}

const AccordionTitleTypography = styled(Typography)`
  text-transform: uppercase;
`;

const LineTypography = styled(Typography)`
  text-transform: uppercase;
  cursor: pointer;
`;

const Container = styled.div`
  margin-bottom: 8px !important;
  border: 1px solid ${props => props.theme.paletteDefault.grey1};
  &:last-child {
    margin-bottom: 0px !important;
  }
`;

const OptionsDropdown: React.FC<OptionsDropdownProps> = props => {
  const { options, selectedColor, onChangeHandler } = props;
  const { t } = useTranslation('product');
  const [selectedOpt, setSelectedOpt] = useState('');
  const [val, setVal] = useState<{ type: string; value: string }[]>([
    { value: '', type: '' },
  ]);

  useEffect(() => {
    setVal([{ value: '', type: '' }]);
  }, [selectedColor]);

  const setValue = (type: string, value: string) => {
    onChangeHandler(type, value);
    setVal(prevVal => {
      const newArrayObj = prevVal.filter(object => {
        return object.type !== type;
      });
      return [...newArrayObj, { type, value }];
    });
  };

  const onAccordionChange = (name: string) => {
    if (selectedOpt === name) {
      setSelectedOpt('');
    } else {
      setSelectedOpt(name);
    }
  };

  return (
    <>
      {options &&
        options.map(option => (
          <Container key={option.name}>
            <Dropdown
              header={
                <AccordionTitleTypography className="smalltitle">
                  {val.find(v => v.type === option.name)?.value ||
                    t('choose') + ' ' + option.name}
                </AccordionTitleTypography>
              }
              onClick={() => onAccordionChange(option.name)}
              expanded={selectedOpt === option.name}>
              {option.values.map((item, index) => (
                <LineTypography
                  key={index}
                  className="smalltitle"
                  onClick={() => setValue(option.name, item)}>
                  {item}
                </LineTypography>
              ))}
            </Dropdown>
          </Container>
        ))}
    </>
  );
};

export default OptionsDropdown;
